import React from 'react';
import styles from 'components/OverlayDrawer.css';

const OverlayDrawer = ({ active, children, onClickClose, onClickBackdrop }) => {
  if (active) {
    return (
      <div className={styles.container}>
        <div className={styles.backdrop} onClick={onClickBackdrop} />
        <div className={styles.drawer}>
          {children}
        </div>
      </div>
    );
  } else {
    return null;
  }
};

export default OverlayDrawer;
